export default class Partnership {
  constructor(
    partnershipType,
    partnershipCategory,
    partner1, 
    partner2,
    suitabilityCallback
  ) {
    this.partnershipType = partnershipType;
    this.partnershipCategory = partnershipCategory;
    this.partner1 = partner1;
    this.partner2 = partner2;
    this._styleSuitabilityCallback = suitabilityCallback;
  }

  
  suitableForPlayingStyle(coreStyle, attackingStyle) {
    return this._styleSuitabilityCallback(coreStyle, attackingStyle);
  }
}
